import React from 'react';

/** Hairline divider. Horizontal by default; `vertical` for inline separation. */
export function Divider({ vertical = false, strong = false, spacing = 0, style }) {
  const color = strong ? 'var(--line-normal-normal)' : 'var(--line-normal-neutral)';
  if (vertical) {
    return <span style={{ display: 'inline-block', width: 1, alignSelf: 'stretch', background: color, margin: `0 ${spacing}px`, ...style }} />;
  }
  return <hr style={{ border: 'none', height: 1, background: color, margin: `${spacing}px 0`, width: '100%', ...style }} />;
}

export default Divider;
